
import { Card } from './types';

/**
 * All shop units — organized by tier.
 * Non-neutral cards have a `tribe` field for synergy.
 * Old `tribal_rock`/`tribal_cholo` tags replaced by typed `tribe` field.
 */
export const neutralUnits: Card[] = [
  // === TIER 1 ===
  {
    "id": "neutral_street_cat",
    "name": "Street Cat",
    "faction": "neutral",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "Last Breath: Summon a 1/1 Kitten.",
    "tags": ["lastbreath"],
    "abilities": [
      {
        "id": "summon_token",
        "trigger": "lastbreath",
        "params": { "tokenId": "token_kitten" }
      }
    ]
  },
  {
    "id": "neutral_alley_troublemaker",
    "name": "Alley Troublemaker",
    "faction": "neutral",
    "tier": 1,
    "attack": 2,
    "health": 1,
    "text": "Summon: Give a friendly unit +1 Attack this combat.",
    "tags": ["summon"],
    "abilities": [
      {
        "id": "buff_random_friendly_for_combat",
        "trigger": "summon",
        "params": { "attack": 1, "health": 0 }
      }
    ]
  },
  {
    "id": "neutral_bottle_collector",
    "name": "Botellero",
    "faction": "neutral",
    "tier": 1,
    "attack": 1,
    "health": 2,
    "text": "Passive: Minions you sell give +1 extra gold.",
    "tags": ["economy"],
    "abilities": [
      {
        "id": "extra_gold_on_sell",
        "trigger": "on_sell",
        "params": { "amount": 1 }
      }
    ],
    "tribe": "la_clica"
  },
  {
    "id": "neutral_side_hustler",
    "name": "El del Hustle",
    "faction": "neutral",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "At the start of your turn, gain +1 Attack this combat.",
    "tags": [],
    "abilities": [
      {
        "id": "buff_self_for_combat",
        "trigger": "start_of_combat",
        "params": { "attack": 1, "health": 0 }
      }
    ],
    "tribe": "la_clica"
  },
  // La Clica T1
  {
    "id": "t1_cholo_corner_scout",
    "name": "El Mirón de Esquina",
    "attack": 2,
    "health": 2,
    "tier": 1,
    "faction": "cholo",
    "tribe": "la_clica",
    "text": "",
    "flavorText": "Always watching, always ready.",
    "tags": ["tempo", "utility"]
  },
  // La Tocada T1
  {
    "id": "t1_rock_basement_drummer",
    "name": "El Baterista del Sótano",
    "attack": 1,
    "health": 3,
    "tier": 1,
    "faction": "emo",
    "tribe": "la_tocada",
    "text": "",
    "flavorText": "Keeping the beat since '99.",
    "tags": ["tank", "tempo"]
  },
  {
    "id": "t1_neutral_taco_vendor",
    "name": "El Taquero de Noche",
    "attack": 1,
    "health": 4,
    "tier": 1,
    "faction": "neutral",
    "text": "",
    "flavorText": "Best tacos in the city, no cap.",
    "tags": ["tempo", "sturdy"],
    "tribe": "la_clica"
  },
  {
    "id": "t1_neutral_stray_dog",
    "name": "El Callejero",
    "attack": 3,
    "health": 1,
    "tier": 1,
    "faction": "neutral",
    "text": "",
    "flavorText": "Scrappy and fearless.",
    "tags": ["aggressive", "glass_cannon"]
  },
  // La Clica T1
  {
    "id": "t1_cholo_alley_messenger",
    "name": "El Mensajero",
    "attack": 1,
    "health": 3,
    "tier": 1,
    "faction": "cholo",
    "tribe": "la_clica",
    "text": "",
    "flavorText": "Word travels fast on these streets.",
    "tags": ["utility", "tempo"]
  },
  // Plaqueros T1
  {
    "id": "t1_cholo_tag_runner",
    "name": "El Corredor de Placas",
    "attack": 2,
    "health": 1,
    "tier": 1,
    "faction": "cholo",
    "tribe": "plaqueros",
    "text": "",
    "flavorText": "Quick tags, quicker feet.",
    "tags": ["aggressive", "glass_cannon"]
  },
  // Anclas del Backyard T1
  {
    "id": "t1_rock_open_mic_kid",
    "name": "El Chavalo del Micrófono",
    "attack": 1,
    "health": 4,
    "tier": 1,
    "faction": "emo",
    "tribe": "anclas",
    "text": "",
    "flavorText": "Everyone's gotta start somewhere.",
    "tags": ["tempo", "backline"]
  },
  // Slameros T1
  {
    "id": "t1_rock_mixtape_trader",
    "name": "El Traficante de Mixtapes",
    "attack": 2,
    "health": 2,
    "tier": 1,
    "faction": "emo",
    "tribe": "slameros",
    "text": "",
    "flavorText": "Fire tracks for a fair price.",
    "tags": ["economy", "flex"]
  },
  {
    "id": "t1_neutral_bus_stop_regular",
    "name": "Bus Stop Regular",
    "attack": 1,
    "health": 5,
    "tier": 1,
    "faction": "neutral",
    "text": "",
    "flavorText": "Been waiting here since Tuesday.",
    "tags": ["sturdy", "frontline"]
  },
  // Bajitos T1 (NEW)
  {
    "id": "t1_cholo_hydraulic_apprentice",
    "name": "El Aprendiz Hidráulico",
    "attack": 2,
    "health": 3,
    "tier": 1,
    "faction": "cholo",
    "tribe": "bajitos",
    "text": "Summon: Swap this unit's Attack and Health.",
    "flavorText": "Learning the bounce.",
    "tags": ["swap"],
    "abilities": [{ "id": "swap_own_stats", "trigger": "summon", "params": {} }]
  },

  // === TIER 2 ===
  {
    "id": "neutral_corner_vendor",
    "name": "Esquinero",
    "faction": "neutral",
    "tier": 2,
    "attack": 2,
    "health": 3,
    "text": "Summon: Add a random Tier 1 minion to your hand.",
    "tags": ["economy"],
    "tribe": "la_clica",
    "abilities": [{ "id": "add_random_card_to_hand", "trigger": "summon", "params": { "tier": 1 } }]
  },
  {
    "id": "neutral_urban_scout",
    "name": "El Explorador de Barrio",
    "faction": "neutral",
    "tier": 2,
    "attack": 3,
    "health": 2,
    "text": "Start of combat: If you control 3 or more different tribes, gain +1 Attack this combat.",
    "tags": ["tribe"],
    "abilities": [{ "id": "buff_self_if_tribe_variety", "trigger": "start_of_combat", "params": { "count": 3, "attack": 1, "health": 0 } }]
  },
  {
    "id": "neutral_trash_panda",
    "name": "El Mapache del Callejón",
    "faction": "neutral",
    "tier": 2,
    "attack": 2,
    "health": 2,
    "text": "Last Breath: Give a random friendly unit +1/+1.",
    "tags": ["lastbreath"],
    "abilities": [
      {
        "id": "buff_random_friendly",
        "trigger": "lastbreath",
        "params": { "attack": 1, "health": 1 }
      }
    ]
  },
  {
    "id": "neutral_graffiti_tag_fan",
    "name": "Plaquero Aficionado",
    "faction": "neutral",
    "tier": 2,
    "attack": 1,
    "health": 4,
    "text": "End of turn: A random friendly unit gains +1 Health.",
    "tags": ["support"],
    "abilities": [{ "id": "buff_random_end_of_turn", "trigger": "end_of_turn", "params": { "attack": 0, "health": 1 } }],
    "tribe": "plaqueros"
  },
  // Bajitos T2
  {
    "id": "t2_cholo_street_mechanic",
    "name": "El Morro del Taller",
    "attack": 2,
    "health": 4,
    "tier": 2,
    "faction": "cholo",
    "tribe": "bajitos",
    "text": "",
    "flavorText": "Can fix anything with duct tape.",
    "tags": ["support", "frontline"]
  },
  // La Clica T2
  {
    "id": "t2_cholo_block_captain",
    "name": "Capitán de Cuadra",
    "attack": 3,
    "health": 3,
    "tier": 2,
    "faction": "cholo",
    "tribe": "la_clica",
    "text": "",
    "flavorText": "Respect is earned, not given.",
    "tags": ["leader"]
  },
  // La Tocada T2
  {
    "id": "t2_rock_flyer_kid",
    "name": "Repartidor",
    "attack": 2,
    "health": 3,
    "tier": 2,
    "faction": "emo",
    "tribe": "la_tocada",
    "text": "",
    "flavorText": "Show's tonight, don't miss it!",
    "tags": ["support"]
  },
  // Slameros T2
  {
    "id": "t2_rock_merch_seller",
    "name": "Vendedor de Merch",
    "attack": 3,
    "health": 2,
    "tier": 2,
    "faction": "emo",
    "tribe": "slameros",
    "text": "",
    "flavorText": "T-shirts and stickers, support the band!",
    "tags": ["economy", "tempo"]
  },
  // La Clica T2
  {
    "id": "t2_cholo_chain_swinger",
    "name": "El Cadeneador",
    "attack": 3,
    "health": 2,
    "tier": 2,
    "faction": "cholo",
    "tribe": "la_clica",
    "text": "",
    "flavorText": "Don't test the chain.",
    "tags": ["aggressive", "frontline"]
  },
  // La Clica T2
  {
    "id": "t2_cholo_casual_lotto",
    "name": "Lotero",
    "attack": 2,
    "health": 4,
    "tier": 2,
    "faction": "cholo",
    "tribe": "la_clica",
    "text": "",
    "flavorText": "This time I'm gonna win big.",
    "tags": ["economy", "utility"]
  },
  // Anclas del Backyard T2
  {
    "id": "t2_rock_thrift_hunter",
    "name": "El Tianguista",
    "attack": 2,
    "health": 4,
    "tier": 2,
    "faction": "emo",
    "tribe": "anclas",
    "text": "",
    "flavorText": "One person's trash is my treasure.",
    "tags": ["value", "support"]
  },
  // La Tocada T2
  {
    "id": "t2_rock_backyard_bassist",
    "name": "Bajista del Backyard",
    "attack": 3,
    "health": 3,
    "tier": 2,
    "faction": "emo",
    "tribe": "la_tocada",
    "text": "",
    "flavorText": "The low end holds it all together.",
    "tags": ["tempo"]
  },
  {
    "id": "t2_neutral_food_cart_guard",
    "name": "Guardián de Carrito",
    "attack": 3,
    "health": 3,
    "tier": 2,
    "faction": "neutral",
    "text": "",
    "flavorText": "Nobody messes with the cart.",
    "tags": ["frontline", "protector"]
  },
  // Anclas del Backyard T2 (NEW)
  {
    "id": "t2_rock_first_aid_punk",
    "name": "Punk Medic",
    "attack": 2,
    "health": 4,
    "tier": 2,
    "faction": "emo",
    "tribe": "anclas",
    "text": "Reborn",
    "flavorText": "Patches you up between sets.",
    "tags": ["reborn", "sticky"],
    "flags": { "reborn": true }
  },

  // === TIER 3 ===
  {
    "id": "neutral_backup_dancer",
    "name": "Bailarín de Respaldo",
    "faction": "neutral",
    "tier": 3,
    "attack": 4,
    "health": 3,
    "text": "Start of combat: Swap positions with the unit to its right.",
    "tags": ["positioning"],
    "abilities": [{ "id": "swap_with_right", "trigger": "start_of_combat", "params": {} }]
  },
  {
    "id": "neutral_flash_photographer",
    "name": "Fotógrafo Flash",
    "faction": "neutral",
    "tier": 3,
    "attack": 3,
    "health": 4,
    "text": "Once per combat: After your first unit attacks, give it +1/+1 permanently.",
    "tags": ["scaling"],
    "abilities": [{ "id": "buff_ally_on_first_attack", "trigger": "on_first_attack", "params": { "attack": 1, "health": 1 } }]
  },
  {
    "id": "neutral_vending_machine",
    "name": "Máquina Vendedora",
    "faction": "neutral",
    "tier": 3,
    "attack": 2,
    "health": 6,
    "text": "Summon: Your next shop refresh this turn costs 0.",
    "tags": ["economy"],
    "abilities": [{ "id": "grant_free_refresh", "trigger": "passive", "params": { "count": 1 } }]
  },
  {
    "id": "neutral_dumpster_diver",
    "name": "Basurero",
    "faction": "neutral",
    "tier": 3,
    "attack": 3,
    "health": 3,
    "text": "Whenever a friendly unit dies, gain +1 Health this combat.",
    "tags": [],
    "abilities": [{ "id": "buff_self_on_friendly_death", "trigger": "on_friendly_death", "params": { "attack": 0, "health": 1 } }]
  },
  // Plaqueros T3
  {
    "id": "t3_cholo_graffiti_artist",
    "name": "Artista de Placas",
    "attack": 3,
    "health": 4,
    "tier": 3,
    "faction": "cholo",
    "tribe": "plaqueros",
    "text": "",
    "flavorText": "My art speaks louder than words.",
    "tags": ["scaling"]
  },
  // Bajitos T3
  {
    "id": "t3_cholo_lowrider_driver",
    "name": "Chofer Bajito",
    "attack": 4,
    "health": 3,
    "tier": 3,
    "faction": "cholo",
    "tribe": "bajitos",
    "text": "",
    "flavorText": "Low and slow, that's the way.",
    "tags": ["frontline", "burst"]
  },
  // Slameros T3
  {
    "id": "t3_rock_stage_diver",
    "name": "Saltarín del Escenario",
    "attack": 4,
    "health": 2,
    "tier": 3,
    "faction": "emo",
    "tribe": "slameros",
    "text": "",
    "flavorText": "Catch me if you can!",
    "tags": ["aggressive", "initiative"]
  },
  // Anclas del Backyard T3
  {
    "id": "t3_rock_zine_writer",
    "name": "Cuadernista",
    "attack": 2,
    "health": 5,
    "tier": 3,
    "faction": "emo",
    "tribe": "anclas",
    "text": "",
    "flavorText": "The underground press lives on.",
    "tags": ["support", "scaling"]
  },
  // La Clica T3
  {
    "id": "t3_cholo_block_planner",
    "name": "Organizador",
    "attack": 3,
    "health": 5,
    "tier": 3,
    "faction": "cholo",
    "tribe": "la_clica",
    "text": "",
    "flavorText": "Every party needs organization.",
    "tags": ["support"]
  },
  // La Clica T3
  {
    "id": "t3_cholo_night_watch",
    "name": "De la Ronda Nocturna",
    "attack": 4,
    "health": 4,
    "tier": 3,
    "faction": "cholo",
    "tribe": "la_clica",
    "text": "",
    "flavorText": "I got the night shift covered.",
    "tags": ["frontline", "tank"]
  },
  // Slameros T3
  {
    "id": "t3_rock_diy_punk",
    "name": "Punk DIY",
    "attack": 4,
    "health": 3,
    "tier": 3,
    "faction": "emo",
    "tribe": "slameros",
    "text": "",
    "flavorText": "Do it yourself or don't do it at all.",
    "tags": ["aggressive"]
  },
  // La Tocada T3
  {
    "id": "t3_rock_busking_guitarist",
    "name": "Guitarrista Callejero",
    "attack": 3,
    "health": 4,
    "tier": 3,
    "faction": "emo",
    "tribe": "la_tocada",
    "text": "",
    "flavorText": "Tips appreciated, smiles are free.",
    "tags": ["economy", "scaling"]
  },
  {
    "id": "t3_neutral_corner_barfly",
    "name": "Regular de Cantina",
    "attack": 2,
    "health": 7,
    "tier": 3,
    "faction": "neutral",
    "text": "",
    "flavorText": "I've been here longer than the bartender.",
    "tags": ["tank", "sticky"]
  },

  // === TIER 4 ===
  {
    "id": "neutral_city_medic",
    "name": "Street Medic",
    "faction": "neutral",
    "tier": 4,
    "attack": 3,
    "health": 7,
    "text": "Start of combat: Heal adjacent units for 2.",
    "tags": ["support"],
    "abilities": [{ "id": "heal_adjacent_start_combat", "trigger": "start_of_combat", "params": { "health": 2 } }]
  },
  {
    "id": "neutral_street_performer",
    "name": "Artista Callejero",
    "faction": "neutral",
    "tier": 4,
    "attack": 5,
    "health": 4,
    "text": "Last Breath: Summon a 2/2 Copy with no abilities.",
    "tags": ["lastbreath"],
    "abilities": [{ "id": "summon_token", "trigger": "lastbreath", "params": { "tokenId": "token_street_copy" } }]
  },
  {
    "id": "neutral_veteran_wanderer",
    "name": "Vagabundo Veterano",
    "faction": "neutral",
    "tier": 4,
    "attack": 4,
    "health": 6,
    "text": "End of turn: If you bought 3 or more units this turn, gain +2/+2.",
    "tags": ["scaling"],
    "abilities": [{ "id": "buff_self_if_bought_enough", "trigger": "end_of_turn", "params": { "count": 3, "attack": 2, "health": 2 } }]
  },
  {
    "id": "neutral_market_bouncer",
    "name": "Guardaespaldas",
    "faction": "neutral",
    "tier": 4,
    "attack": 6,
    "health": 3,
    "text": "Guard. The first time this takes damage each combat, gain +4 Health.",
    "tags": ["guard"],
    "abilities": [
      { "id": "guard", "trigger": "start_of_combat", "params": {} },
      { "id": "buff_self_on_first_damage", "trigger": "on_take_damage", "params": { "attack": 0, "health": 4 } }
    ]
  },
  // La Clica T4
  {
    "id": "t4_cholo_hood_elder",
    "name": "Anciano del Barrio",
    "attack": 3,
    "health": 7,
    "tier": 4,
    "faction": "cholo",
    "tribe": "la_clica",
    "text": "",
    "flavorText": "Wisdom comes with age and scars.",
    "tags": ["tank", "leader"]
  },
  // La Tocada T4
  {
    "id": "t4_rock_sound_engineer",
    "name": "Ingeniero de Sonido",
    "attack": 4,
    "health": 5,
    "tier": 4,
    "faction": "emo",
    "tribe": "la_tocada",
    "text": "",
    "flavorText": "Perfect sound takes precision.",
    "tags": ["support", "buffer"]
  },
  {
    "id": "t4_neutral_city_bouncer",
    "name": "Botero del Club",
    "attack": 5,
    "health": 5,
    "tier": 4,
    "faction": "neutral",
    "text": "",
    "flavorText": "You're not on the list.",
    "tags": ["frontline", "guard_like"]
  },
  // La Clica T4
  {
    "id": "t4_cholo_street_chaplain",
    "name": "Padre del Barrio",
    "attack": 4,
    "health": 6,
    "tier": 4,
    "faction": "cholo",
    "tribe": "la_clica",
    "text": "",
    "flavorText": "Faith and familia, that's all we need.",
    "tags": ["support", "leader"]
  },
  // Anclas del Backyard T4
  {
    "id": "t4_rock_van_driver",
    "name": "Chofer de Gira",
    "attack": 5,
    "health": 5,
    "tier": 4,
    "faction": "emo",
    "tribe": "anclas",
    "text": "",
    "flavorText": "Been on the road since '05.",
    "tags": ["frontline", "utility"]
  },
  {
    "id": "t4_neutral_warehouse_guard",
    "name": "Vigilante de Almacén",
    "attack": 4,
    "health": 7,
    "tier": 4,
    "faction": "neutral",
    "text": "",
    "flavorText": "Nothing gets past me on my watch.",
    "tags": ["tank", "late_game"]
  },
  // Plaqueros T4
  {
    "id": "t4_cholo_driveby_specialist",
    "name": "Especialista de Drive-By",
    "attack": 6,
    "health": 4,
    "tier": 4,
    "faction": "cholo",
    "tribe": "plaqueros",
    "text": "Overkill: excess damage spills to the next enemy.",
    "flavorText": "Hit 'em fast, hit 'em hard.",
    "tags": [
      "burst",
      "frontline",
      "overkill"
    ],
    "flags": {
      "overkill": true
    }
  },
  // La Tocada T4
  {
    "id": "t4_rock_underground_promoter",
    "name": "Promotor Underground",
    "attack": 4,
    "health": 6,
    "tier": 4,
    "faction": "emo",
    "tribe": "la_tocada",
    "text": "",
    "flavorText": "I know all the best underground shows.",
    "tags": ["support", "economy"]
  },
  // Bajitos T4 (NEW)
  {
    "id": "t4_cholo_custom_frame_builder",
    "name": "Constructor de Cuadros",
    "attack": 4,
    "health": 6,
    "tier": 4,
    "faction": "cholo",
    "tribe": "bajitos",
    "text": "Start of combat: Set this unit's Attack equal to its Health.",
    "flavorText": "Every frame is a work of art.",
    "tags": ["swap", "frontline"],
    "abilities": [{ "id": "set_attack_to_health", "trigger": "start_of_combat", "params": {} }]
  },

  // === TIER 5 ===
  {
    "id": "neutral_city_guardian",
    "name": "Guardián de Ciudad",
    "faction": "neutral",
    "tier": 5,
    "attack": 6,
    "health": 8,
    "text": "Your other units have +1/+1.",
    "tags": ["aura"],
    "abilities": [{ "id": "aura_buff_other_units_combat", "trigger": "start_of_combat", "params": { "attack": 1, "health": 1 } }]
  },
  {
    "id": "neutral_street_sage",
    "name": "Sabio Callejero",
    "faction": "neutral",
    "tier": 5,
    "attack": 4,
    "health": 9,
    "text": "Whenever a friendly unit gains permanent stats, gain +1 Attack.",
    "tags": ["scaling"],
    "abilities": [{ "id": "watch_friendly_gain_stats", "trigger": "passive", "params": { "attack": 1, "health": 0 } }]
  },
  {
    "id": "neutral_night_market_dealer",
    "name": "Traficante de Mercado",
    "faction": "neutral",
    "tier": 5,
    "attack": 5,
    "health": 6,
    "text": "Summon: Discover a minion from the previous tier.",
    "tags": ["economy"],
    "abilities": [{ "id": "discover_unit", "trigger": "summon", "params": { "tierOffset": -1 } }]
  },
  {
    "id": "neutral_lone_survivor",
    "name": "Superviviente Solitario",
    "faction": "neutral",
    "tier": 5,
    "attack": 7,
    "health": 7,
    "text": "If this is your only unit at the start of combat, gain +7/+7 this combat.",
    "tags": ["scaling"],
    "abilities": [{ "id": "buff_self_if_only_unit", "trigger": "start_of_combat", "params": { "attack": 7, "health": 7 } }]
  },
  // Plaqueros T5
  {
    "id": "t5_cholo_legendary_og",
    "name": "Leyenda del Barrio",
    "attack": 6,
    "health": 7,
    "tier": 5,
    "faction": "cholo",
    "tribe": "plaqueros",
    "text": "End of turn: Tag your highest-Attack Plaquero twice (+2/+2 permanently).",
    "flavorText": "They'll tell stories about me for decades.",
    "tags": [
      "leader",
      "scaling",
      "snowball"
    ],
    "abilities": [
      {
        "id": "plaque_tag_highest",
        "trigger": "end_of_turn",
        "params": {
          "count": 2
        }
      }
    ]
  },
  // Slameros T5
  {
    "id": "t5_rock_scene_icon",
    "name": "Leyenda del Pit",
    "attack": 7,
    "health": 5,
    "tier": 5,
    "faction": "emo",
    "tribe": "slameros",
    "text": "Start of combat: Gain +3 Attack for each other Slamero.",
    "flavorText": "Everyone knows my name in this scene.",
    "tags": [
      "carry",
      "scaling"
    ],
    "abilities": [
      {
        "id": "buff_self_per_tribe",
        "trigger": "start_of_combat",
        "params": {
          "tribe": "slameros",
          "attackPer": 3,
          "healthPer": 0
        }
      }
    ]
  },
  {
    "id": "t5_neutral_block_og_bartender",
    "name": "Cantinero Legendario",
    "attack": 6,
    "health": 8,
    "tier": 5,
    "faction": "neutral",
    "text": "End of turn: Give a random friendly unit +2/+2 permanently.",
    "flavorText": "I've seen it all behind this bar.",
    "tags": [
      "support",
      "late_game",
      "scaling"
    ],
    "abilities": [
      {
        "id": "buff_random_end_of_turn",
        "trigger": "end_of_turn",
        "params": {
          "attack": 2,
          "health": 2
        }
      }
    ]
  },
  // La Clica T5
  {
    "id": "t5_cholo_block_general",
    "name": "Mero Mero de la Clica",
    "attack": 7,
    "health": 7,
    "tier": 5,
    "faction": "cholo",
    "tribe": "la_clica",
    "text": "Summon: Summon two 4/4 Morritos.",
    "flavorText": "I run this block with honor and respect.",
    "tags": [
      "leader",
      "late_game",
      "swarm"
    ],
    "abilities": [
      {
        "id": "summon_multiple_tokens",
        "trigger": "summon",
        "params": {
          "tokenId": "token_morrito_grande",
          "count": 2
        }
      }
    ]
  },
  // La Clica T5
  {
    "id": "t5_cholo_car_show_champion",
    "name": "Campeón del Cruise",
    "attack": 6,
    "health": 8,
    "tier": 5,
    "faction": "cholo",
    "tribe": "bajitos",
    "text": "Start of combat: Set this unit's Attack equal to its Health.",
    "flavorText": "First place at every show.",
    "tags": [
      "frontline",
      "scaling",
      "swap"
    ],
    "abilities": [
      {
        "id": "set_attack_to_health",
        "trigger": "start_of_combat",
        "params": {}
      }
    ]
  },
  // Anclas del Backyard T5
  {
    "id": "t5_rock_festival_booker",
    "name": "Promotor de Festival",
    "attack": 5,
    "health": 9,
    "tier": 5,
    "faction": "emo",
    "tribe": "anclas",
    "text": "Start of combat: All Anclas del Backyard gain +0/+6.",
    "flavorText": "I make careers with one phone call.",
    "tags": [
      "support",
      "late_game"
    ],
    "abilities": [
      {
        "id": "buff_tribe_combat",
        "trigger": "start_of_combat",
        "params": {
          "tribe": "anclas",
          "attack": 0,
          "health": 6
        }
      }
    ]
  },
  // La Tocada T5 (NEW)
  {
    "id": "t5_rock_headliner_manager",
    "name": "Booker de Tocada",
    "attack": 5,
    "health": 7,
    "tier": 5,
    "faction": "emo",
    "tribe": "la_tocada",
    "text": "Aura: Your other units have +1/+1.",
    "flavorText": "I make stars out of nobodies.",
    "tags": ["aura", "support"],
    "abilities": [{ "id": "aura_buff_other_units_combat", "trigger": "start_of_combat", "params": { "attack": 1, "health": 1 } }]
  },
  // Anclas del Backyard T5 (NEW)
  {
    "id": "t5_rock_festival_security",
    "name": "Jefe de Seguridad",
    "attack": 5,
    "health": 10,
    "tier": 5,
    "faction": "emo",
    "tribe": "anclas",
    "text": "Start of combat: All Anclas del Backyard gain +2 Health.",
    "flavorText": "Nobody causes trouble on my watch.",
    "tags": ["tank", "support"],
    "abilities": [{ "id": "buff_tribe_combat", "trigger": "start_of_combat", "params": { "tribe": "anclas", "attack": 0, "health": 2 } }]
  },
  // Bajitos T5 (NEW)
  {
    "id": "t5_cholo_cruise_night_legend",
    "name": "Mero Mero del Cruise",
    "attack": 5,
    "health": 7,
    "tier": 5,
    "faction": "cholo",
    "tribe": "bajitos",
    "text": "Start of combat: All Bajitos gain +2 to their lower stat.",
    "flavorText": "The boulevard belongs to us tonight.",
    "tags": ["support", "swap"],
    "abilities": [{ "id": "buff_tribe_lower_stat", "trigger": "start_of_combat", "params": { "tribe": "bajitos", "amount": 2 } }]
  },

  // === TIER 6 ===
  {
    "id": "neutral_the_giant",
    "name": "Gigante",
    "faction": "neutral",
    "tier": 6,
    "attack": 10,
    "health": 10,
    "text": "Summon: Give your other units +2/+2.",
    "tags": [
      "buff"
    ],
    "abilities": [
      {
        "id": "buff_all_other_units",
        "trigger": "summon",
        "params": {
          "attack": 2,
          "health": 2
        }
      }
    ]
  },
  {
    "id": "neutral_rooftop_sniper",
    "name": "Francotirador",
    "faction": "neutral",
    "tier": 6,
    "attack": 12,
    "health": 6,
    "text": "Start of combat: Deal 3 damage to two random enemies.",
    "tags": [
      "damage"
    ],
    "abilities": [
      {
        "id": "damage_random_enemies",
        "trigger": "start_of_combat",
        "params": {
          "damage": 3,
          "count": 2
        }
      }
    ]
  },
  {
    "id": "neutral_urban_colossus",
    "name": "Coloso Urbano",
    "faction": "neutral",
    "tier": 6,
    "attack": 8,
    "health": 14,
    "text": "Guard. Whenever this takes damage, gain +1/+1 permanently.",
    "tags": ["guard", "scaling"],
    "abilities": [
      { "id": "guard", "trigger": "start_of_combat", "params": {} },
      { "id": "buff_self_on_damage", "trigger": "on_take_damage", "params": { "attack": 1, "health": 1 } }
    ]
  },
  {
    "id": "neutral_phantom_vendor",
    "name": "Vendedor Fantasma",
    "faction": "neutral",
    "tier": 6,
    "attack": 9,
    "health": 9,
    "text": "Whenever a friendly unit dies, gain +1 Attack this combat.",
    "tags": ["damage"],
    "abilities": [{ "id": "buff_self_on_friendly_death", "trigger": "on_friendly_death", "params": { "attack": 1, "health": 0 } }]
  },
  {
    "id": "t6_neutral_block_party",
    "name": "Reina del Block",
    "attack": 8,
    "health": 8,
    "tier": 6,
    "faction": "neutral",
    "text": "Summon: Give your other units +3/+3.",
    "flavorText": "The whole neighborhood celebrates tonight.",
    "tags": [
      "late_game",
      "support",
      "buff"
    ],
    "abilities": [
      {
        "id": "buff_all_other_units",
        "trigger": "summon",
        "params": {
          "attack": 3,
          "health": 3
        }
      }
    ]
  },
  // Slameros T6
  {
    "id": "t6_rock_legend_frontman",
    "name": "Estelar Mayor",
    "attack": 9,
    "health": 7,
    "tier": 6,
    "faction": "emo",
    "tribe": "slameros",
    "text": "Start of combat: Gain First Strike, Cleave and Overkill.",
    "flavorText": "The crowd goes wild when I take the stage.",
    "tags": [
      "carry",
      "late_game",
      "virgen"
    ],
    "abilities": [
      {
        "id": "grant_self_flags",
        "trigger": "start_of_combat",
        "params": {
          "flags": [
            "firstStrike",
            "cleave",
            "overkill"
          ]
        }
      }
    ]
  },
  // Plaqueros T6
  {
    "id": "t6_cholo_neighborhood_myth",
    "name": "Mito del Barrio",
    "attack": 9,
    "health": 9,
    "tier": 6,
    "faction": "cholo",
    "tribe": "plaqueros",
    "text": "Start of combat: Gain +2/+2 for each Plaque tag on ANY friendly unit.",
    "flavorText": "Some say I'm just a legend. They're wrong.",
    "tags": [
      "carry",
      "leader",
      "late_game",
      "snowball"
    ],
    "abilities": [
      {
        "id": "cash_in_plaque_board",
        "trigger": "start_of_combat",
        "params": {
          "attackPer": 2,
          "healthPer": 2
        }
      }
    ]
  },
  // Anclas del Backyard T6
  {
    "id": "t6_rock_legendary_producer",
    "name": "Don Productor",
    "attack": 8,
    "health": 10,
    "tier": 6,
    "faction": "emo",
    "tribe": "anclas",
    "text": "Start of combat: Give all friendly units Reborn.",
    "flavorText": "Every hit song you know? I made that.",
    "tags": [
      "support",
      "late_game",
      "sticky"
    ],
    "abilities": [
      {
        "id": "grant_all_flags",
        "trigger": "start_of_combat",
        "params": {
          "flags": [
            "reborn"
          ],
          "includeSelf": true
        }
      }
    ]
  },
  {
    "id": "t6_neutral_rooftop_peacemaker",
    "name": "Pacificador de Azotea",
    "attack": 7,
    "health": 11,
    "tier": 6,
    "faction": "neutral",
    "text": "Start of combat: Give all friendly units Divine Shield.",
    "flavorText": "Peace through strength and wisdom.",
    "tags": [
      "tank",
      "late_game",
      "utility"
    ],
    "abilities": [
      {
        "id": "grant_all_flags",
        "trigger": "start_of_combat",
        "params": {
          "flags": [
            "divineShield"
          ],
          "includeSelf": true
        }
      }
    ]
  },
  // La Tocada T6 (NEW)
  {
    "id": "t6_rock_sound_system_architect",
    "name": "Arquitecto de Sonido",
    "attack": 7,
    "health": 9,
    "tier": 6,
    "faction": "emo",
    "tribe": "la_tocada",
    "text": "When you buy a unit, give all friendly units +1 Health.",
    "flavorText": "The sound system that shakes the whole block.",
    "tags": ["support", "late_game"],
    "abilities": [{ "id": "buff_all_on_buy", "trigger": "on_buy", "params": { "attack": 0, "health": 1 } }]
  },
  // Plaqueros T6 — Snowball engine finisher (Phase 2 Slice 1)
  {
    "id": "t6_cholo_la_leyenda_tatuada",
    "name": "La Leyenda Tatuada",
    "attack": 7,
    "health": 7,
    "tier": 6,
    "faction": "cholo",
    "tribe": "plaqueros",
    "text": "Start of combat: Gain +2/+2 for each Plaque tag on this unit.",
    "flavorText": "Cada placa cuenta una historia. Esta tiene todas.",
    "tags": ["snowball", "late_game", "carry"],
    "abilities": [
      { "id": "cash_in_plaque", "trigger": "start_of_combat", "params": { "attackPer": 2, "healthPer": 2 } }
    ]
  },
  // Bajitos T6 (NEW)
  {
    "id": "t6_cholo_lowrider_godfather",
    "name": "Padrino del Bulevar",
    "attack": 6,
    "health": 10,
    "tier": 6,
    "faction": "cholo",
    "tribe": "bajitos",
    "text": "Start of combat: Swap all friendly units' Attack and Health if it increases their total.",
    "flavorText": "The king of the cruise. Every ride bows.",
    "tags": ["swap", "late_game", "virgen"],
    "abilities": [{ "id": "swap_all_if_beneficial", "trigger": "start_of_combat", "params": {} }]
  },

  // === KEYWORD MECHANIC CARDS ===

  // Divine Shield
  {
    "id": "t2_neutral_shielded_vendor",
    "name": "El Pendletón",
    "faction": "neutral",
    "tier": 2,
    "attack": 2,
    "health": 2,
    "text": "Divine Shield",
    "tags": ["divine_shield", "defensive"],
    "flags": { "divineShield": true }
  },
  // Slameros T4 (divine shield)
  {
    "id": "t4_rock_armored_roadie",
    "name": "El Pecho Firme",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 4,
    "attack": 4,
    "health": 5,
    "text": "Divine Shield",
    "tags": ["divine_shield", "frontline"],
    "flags": { "divineShield": true }
  },

  // Poisonous
  {
    "id": "t3_neutral_toxic_dealer",
    "name": "La Aguja del Pit",
    "faction": "neutral",
    "tier": 3,
    "attack": 1,
    "health": 3,
    "text": "Poisonous",
    "tags": ["poisonous", "assassin"],
    "flags": { "poisonous": true }
  },
  // Plaqueros T5 (poisonous)
  {
    "id": "t5_cholo_venom_striker",
    "name": "El Pincho Doble",
    "faction": "cholo",
    "tribe": "plaqueros",
    "tier": 5,
    "attack": 2,
    "health": 4,
    "text": "Poisonous. Divine Shield",
    "tags": ["poisonous", "divine_shield"],
    "flags": { "poisonous": true, "divineShield": true }
  },

  // Reborn
  // Plaqueros T2 (reborn)
  {
    "id": "t2_cholo_persistent_homie",
    "name": "El Renacido del Barrio",
    "faction": "cholo",
    "tribe": "plaqueros",
    "tier": 2,
    "attack": 2,
    "health": 2,
    "text": "Reborn",
    "tags": ["reborn", "sticky"],
    "flags": { "reborn": true }
  },
  {
    "id": "t4_neutral_undying_guardian",
    "name": "La Reencarnada",
    "faction": "neutral",
    "tier": 4,
    "attack": 3,
    "health": 5,
    "text": "Taunt. Reborn",
    "tags": ["reborn", "taunt", "tank"],
    "flags": { "reborn": true }
  },

  // Windfury
  // Slameros T3 (windfury)
  {
    "id": "t3_rock_dual_striker",
    "name": "El Doble Codazo",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 3,
    "attack": 3,
    "health": 2,
    "text": "Windfury",
    "tags": ["windfury", "aggressive"],
    "flags": { "windfury": true }
  },
  {
    "id": "t5_neutral_whirlwind_fighter",
    "name": "El Remolino",
    "faction": "neutral",
    "tier": 5,
    "attack": 5,
    "health": 4,
    "text": "Windfury",
    "tags": ["windfury", "carry"],
    "flags": { "windfury": true }
  },

  // Cleave
  // Plaqueros T3 (cleave)
  {
    "id": "t3_cholo_chain_cleaver",
    "name": "La Onda Ancha",
    "faction": "cholo",
    "tribe": "plaqueros",
    "tier": 3,
    "attack": 3,
    "health": 3,
    "text": "Cleave",
    "tags": ["cleave", "aoe"],
    "flags": { "cleave": true }
  },
  // Slameros T5 (cleave)
  {
    "id": "t5_rock_mosh_pit_legend",
    "name": "La Leyenda del Mosh",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 5,
    "attack": 6,
    "health": 5,
    "text": "Cleave",
    "tags": ["cleave", "carry"],
    "flags": { "cleave": true }
  },

  // Avenge
  {
    "id": "t3_neutral_vengeful_brother",
    "name": "Vengeful Brother",
    "faction": "neutral",
    "tier": 3,
    "attack": 2,
    "health": 4,
    "text": "Avenge (1): Gain +2/+1.",
    "tags": ["avenge", "scaling"],
    "abilities": [
      {
        "id": "avenge_buff_self",
        "trigger": "avenge",
        "params": { "threshold": 1, "attack": 2, "health": 1 }
      }
    ]
  },
  // Plaqueros T4 (avenge)
  {
    "id": "t4_cholo_block_avenger",
    "name": "Block Avenger",
    "faction": "cholo",
    "tribe": "plaqueros",
    "tier": 4,
    "attack": 4,
    "health": 5,
    "text": "Avenge (2): Give a random friendly unit +2/+2.",
    "tags": ["avenge", "support"],
    "abilities": [
      {
        "id": "avenge_buff_random",
        "trigger": "avenge",
        "params": { "threshold": 2, "attack": 2, "health": 2 }
      }
    ]
  },
  // Slameros T5 (avenge)
  {
    "id": "t5_rock_crowd_surfer",
    "name": "El Vengador del Pit",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 5,
    "attack": 5,
    "health": 6,
    "text": "Avenge (3): Gain +4/+4.",
    "tags": ["avenge", "scaling", "carry"],
    "abilities": [
      {
        "id": "avenge_buff_self",
        "trigger": "avenge",
        "params": { "threshold": 3, "attack": 4, "health": 4 }
      }
    ]
  },

  // Combo cards
  {
    "id": "t6_neutral_ultimate_warrior",
    "name": "La Triada Invencible",
    "faction": "neutral",
    "tier": 6,
    "attack": 6,
    "health": 6,
    "text": "Divine Shield. Windfury. Reborn",
    "tags": ["divine_shield", "windfury", "reborn", "legendary"],
    "flags": { "divineShield": true, "windfury": true, "reborn": true }
  },
  // La Clica T6 (cleave + poisonous)
  {
    "id": "t6_cholo_street_legend",
    "name": "Leyenda de la Calle",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 6,
    "attack": 8,
    "health": 8,
    "text": "Cleave. Poisonous",
    "tags": ["cleave", "poisonous", "legendary"],
    "flags": { "cleave": true, "poisonous": true }
  },

  // === CALIFORNIA FOIL CARDS (6 new neutrals) ===
  {
    "id": "foil_el_surfer",
    "name": "El Surfer Güero",
    "faction": "neutral",
    "tier": 2,
    "attack": 3,
    "health": 2,
    "text": "Summon: Your opponent's units have -1 Attack this combat.",
    "tags": ["foil", "neutral"],
    "abilities": [{ "id": "debuff_enemy_board", "trigger": "summon", "params": { "attack": -1, "health": 0 } }]
  },
  {
    "id": "foil_la_valley",
    "name": "La Valley",
    "faction": "neutral",
    "tier": 2,
    "attack": 2,
    "health": 3,
    "text": "Aura: Each turn, your units gain +1 Health.",
    "tags": ["foil", "neutral"],
    "abilities": [{ "id": "buff_all_other_units", "trigger": "end_of_turn", "params": { "attack": 0, "health": 1 } }]
  },
  {
    "id": "foil_la_karen",
    "name": "La Karen",
    "faction": "neutral",
    "tier": 3,
    "attack": 1,
    "health": 4,
    "text": "Summon: Your opponent loses 1 gold.",
    "tags": ["foil", "neutral"],
    "abilities": [{ "id": "drain_opponent_gold", "trigger": "summon", "params": { "amount": 1 } }]
  },
  {
    "id": "foil_el_patagonia_vest",
    "name": "El Patagonia Vest",
    "faction": "neutral",
    "tier": 3,
    "attack": 4,
    "health": 2,
    "text": "Whenever you buy a unit, gain +1/+1 until end of combat.",
    "tags": ["foil", "neutral"],
    "abilities": [{ "id": "buff_self_for_combat", "trigger": "on_buy", "params": { "attack": 1, "health": 1 } }]
  },
  {
    "id": "foil_la_mama_del_kale",
    "name": "La Mamá del Kale",
    "faction": "neutral",
    "tier": 4,
    "attack": 2,
    "health": 5,
    "text": "End of turn: Heal all friendly units for 1 and give them +1 Health.",
    "tags": ["foil", "neutral"],
    "abilities": [
      { "id": "buff_all_other_units", "trigger": "end_of_turn", "params": { "attack": 0, "health": 1 } },
      { "id": "buff_self_for_combat", "trigger": "end_of_turn", "params": { "attack": 0, "health": 1 } }
    ]
  },
  {
    "id": "foil_la_del_ring_light",
    "name": "La del Ring Light",
    "faction": "neutral",
    "tier": 4,
    "attack": 3,
    "health": 4,
    "text": "Summon: Copy the Attack and Health of a random friendly unit this combat.",
    "tags": ["foil", "neutral"],
    "abilities": [{ "id": "copy_random_friendly_stats", "trigger": "summon", "params": {} }]
  }
];
